import styled from '@emotion/styled';
import { Button, Tooltip } from '@mui/material';
import { useMediaQuery } from '@mui/system';
import { PersonAdd as AddUserIcon } from '@mui/icons-material';
import TonalIconButton from '@/components/TonalIconButton';
import { FormattedMessage } from 'react-intl';

const StyledInviteButton = styled(Button)(
  {
    marginTop: 13.75,
    marginLeft: 12,
    height: 36.5,
    flexShrink: 0,
  },
  ({ disabled, theme }) => {
    if (disabled) {
      return {
        transition: theme.transitions.create(['margin']),
        marginLeft: -4,
        marginRight: -4,
        height: 36.5,
        backgroundColor: 'transparent !important',
        '> .MuiButton-icon': {
          marginRight: 0,
        },
      };
    }
  },
);

const StyledInviteIconButton = styled(TonalIconButton)({
  marginTop: 12,
  marginLeft: 6,
  height: 40,
});

type InviteButtonProps = {
  loading: boolean;
  disabled: boolean;
};

const InviteButton = ({ loading, disabled }: InviteButtonProps) => {
  const shouldUseIconButton = useMediaQuery('(max-width: 860px)');

  if (shouldUseIconButton) {
    return (
      <Tooltip
        title={
          <FormattedMessage id="portfolio.challenge.sharing.invite_users.form.invite_button" />
        }
      >
        <StyledInviteIconButton
          type="submit"
          disabled={disabled}
          loading={loading}
        >
          <AddUserIcon />
        </StyledInviteIconButton>
      </Tooltip>
    );
  }

  return (
    <StyledInviteButton
      variant="contained"
      startIcon={<AddUserIcon />}
      type="submit"
      disabled={disabled}
      loading={loading}
      loadingPosition="start"
      disableElevation
    >
      {!disabled && (
        <FormattedMessage id="portfolio.challenge.sharing.invite_users.form.invite_button" />
      )}
    </StyledInviteButton>
  );
};

export default InviteButton;
